export const INPUTS_LIST = [
	{ label: "input_callSource", title: "source", type: "text" },
	// { label: "input_noAnswerTimeout", title: "noAnswerTimeout", type: "number" },
	// { label: "input_callTries", title: "dialTries", type: "number" },
	// { label: "input_maxChannels", title: "maxChannels", type: "number" },
	// { label: "input_callTimeout", title: "redialTimeout", type: "number" },
	// { label: "input_lineActivityMonitoring", title: "watchdog", type: "number" },
	{ label: "input_destination", title: "destination", type: "text" },
];
